module.exports = __webpack_public_path__ + "img/banner-text.6a32852.png";